import React from 'react'
import { inject, observer } from 'mobx-react'

import { CustomSelect } from '../../components/select'

export const PacketSelector = inject('packetsStore')(observer(({packetsStore,...props}) =>
<CustomSelect {...props}
  options={packetsStore.options}
/>))
